import React, { createContext, useContext, useMemo, useState } from 'react';

import { Step } from 'react-joyride';

interface JoyrideState {
    run: boolean;
    stepIndex: number;
    steps: Step[];
    tourActive: boolean;
    flowComplete: boolean;
    startedOnboarding: boolean;
    interrupt: boolean;
  }
  

  const joyrideState = {
    run: false,
    stepIndex: 0,
    steps: [],
    tourActive: false,
    flowComplete: false,
    startedOnboarding: false,
    interrupt: false,
  };
  
 export const AppContext = createContext({
    state: joyrideState,
    setState: () => undefined,
  });
  AppContext.displayName = 'AppContext';
  
  export function JoyRideProvider(props: any) {
    const [state, setState] = useState(joyrideState);
  
    const value = useMemo(
      () => ({
        state,
        setState,
      }),
      [setState, state],
    );
  
    return <AppContext.Provider value={value} {...props} />;
  }
  
  export function useAppContext(): {
    setState: (patch: Partial<JoyrideState> | ((previousState: JoyrideState) => Partial<JoyrideState>)) => void;
    state: JoyrideState;
  } {
    const context = useContext(AppContext);
  
    if (!context) {
      throw new Error('useAppContext must be used within a JoyrideProvider');
    }
  
    return context;
  }
  